import { ReactChild, ReactFragment, useEffect, useState } from "react";
import Image from "next/image";
import styles from "../styles/Home.module.css";
import { Box, Button, Heading, Text, Flex, Link } from "rebass";
import { useTheme, ThemeProvider, withTheme } from "@emotion/react";
import styled from "styled-components";
import { Tiles } from "@rebass/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faTwitter,
  faDiscord,
  faMedium,
  faInstagram,
  IconLookup,
} from "@fortawesome/free-brands-svg-icons";
import { faBook } from "@fortawesome/free-solid-svg-icons"
import { faAt, faCube } from "@fortawesome/free-solid-svg-icons";
import {
  faFileZipper,
  faFileArchive,
} from "@fortawesome/free-regular-svg-icons";
import theme from "../styles/LLTheme";

const Footer2 = () => {
  const socialLink = (
    icon: IconLookup,
    name: string,
    color: string,
    link: string | null
  ) => {
    return (
      <Button
        onClick={() => {
          link && window.open(link)?.focus();
        }}
        sx={{
          backgroundColor: "#7678ED",
          cursor: "pointer",
          border: "2px solid #FFFFFF",
          borderRadius: "40px",
          transition: "all 0.3s",
          ":hover": {
            backgroundColor: "#fff",
            color: "#7678ED",
          }
        }}
      >
        <Flex
          sx={{ justifyContent: "center", alignItems: "center", gap: "8px" }}
        >
          <FontAwesomeIcon
            icon={icon}
            style={{ fontSize: "25px", zIndex: 99 }}
          />
          <Text fontSize={["0.8em", "0.9em", "1em"]}>{name}</Text>
        </Flex>
      </Button>
    );
  };
  const connection = (
    icon: IconLookup,
    name: string,
    color: string,
    link: string | null
  ) => {
    return (
      <Button
        onClick={() => {
          link && window.open(link)?.focus();
        }}
        sx={{
          backgroundColor: "#282828",
          cursor: "pointer",
          marginLeft: "0px",
          paddingLeft: "0px"
          // ':hover': {
          //   backgroundColor: '#333333',
          // }
        }}
      >
        <Flex sx={{ justifyContent: "left", alignItems: "left", gap: "8px" }}>
          <FontAwesomeIcon
            icon={icon}
            style={{ color: color, fontSize: "20px", zIndex: 99 }}
          />
          <Text
            fontSize={["14px", "14px", "18px"]}
            sx={{ color: "#FFFFFF", fontWeight: "normal" }}
          >
            {name}
          </Text>
        </Flex>
      </Button>
    );
  };
  const ReleaseCard = ({
    title,
    body,
    stage,
    time,
  }: {
    title: string;
    body: string;
    stage: string;
    time: string;
  }) => {
    return (
      <Flex
        sx={{
          alignItems: "flex-start",
          maxWidth: "200px",
          // paddingLeft:"110%",
          [theme.breakpoints.down("md")]: {
            padding: "20px 0",
          },
        }}
        flexDirection="column"
      >
        <Text
          fontSize={["18px", "18px", "22px"]}
          sx={{
            color: "#FFFFFF",
            fontFamily: "Inter,sans-serif",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Text>
        {body == "" ? (
          <br />
        ) : (
          <Text
            fontSize={["16px", "16px", "20px"]}
            sx={{
              color: "rgba(255, 255, 255, 1)",
              fontFamily: "Inter,sans-serif",
              fontWeight: "normal",
            }}
          >
            {body}
          </Text>
        )}
        <Flex
          sx={{ borderTop: "solid 2px rgba(255, 255, 255, 0.24)" }}
          mt="32px"
          pt="12px"
          flexDirection="column"
        >
          <Text
            fontSize={["16px", "16px", "20px"]}
            sx={{
              color: "#FFFFFF",
              fontFamily: "Inter,sans-serif",
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            {stage}
          </Text>
          <Text
            fontSize={["16px", "16px", "20px"]}
            sx={{
              color: "#FFFFFF",
              fontFamily: "Inter,sans-serif",
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            <span> {time}</span>
          </Text>
        </Flex>
      </Flex>
    );
  };
  return (
    <Flex width="100%" flexDirection="column">
      <Flex
        width="100%"
        backgroundColor="#7678ED"
        sx={{ gap: "5%" }}
      >
        <Tiles columns={[1,2,2]} alignItems="center" py="30px" sx={{margin: "0 auto", width:"100%", paddingLeft: "10%", paddingRight: "10%"}}>
          <Text
            fontSize={["25px", "30px", "40px"]}
            sx={{
              fontFamily: "Inter",
              fontWeight: "700",
              display: "flex",
              flexDirection: "column",
              // letterSpacing: "0.04em",
              flex: 1,
              [theme.breakpoints.down("md")]: {
                textAlign: "start",
              },
              position: "relative",
            }}
          >
            Look for integration?
          </Text>
          <Tiles columns={[2,2,3]} sx={{ my: "20px", gap: "10px", justifyContent: "flex-end"}}>
            {socialLink(
              faBook,
              "Documentation",
              "#FFFFFF",
              "https://twitter.com/lilico_app"
            )}
            {socialLink(
              faDiscord,
              "Discord",
              "#FFFFFF",
              "https://discord.gg/DtZkFTay2U"
            )}
            {socialLink(
              faTwitter,
              "Twitter",
              "#FFFFFF",
              "https://twitter.com/lilico_app"
            )}
          </Tiles>
        </Tiles>
        </Flex>
      <Flex
        width="100%"
        // flexDirection="column"
        backgroundColor="#282828"
        py="56px"
        sx={{ gap: "5%" }}
      >
        <Flex px="10%" >
        <Tiles columns={[1, 2]}>
          <Flex
            flexDirection="column"
            // sx={{gap:"0px"}}
          >
            <Text
              fontSize={["16px", "20px", "24px"]}
              sx={{
                color: "#FFFFFF",
                fontFamily: "Inter,sans-serif",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
                flex: 1,
                [theme.breakpoints.down("md")]: {
                  textAlign: "start",
                },
                position: "relative",
              }}
            >
              <span>Copyright © 2022 Outblock.</span>
              <span>All rights reserved.</span>
            </Text>
            <Box width={[70, 85, 100]} height={[70, 85, 100]}>
              <Image
                src="/Outblock.svg"
                width={"100%"}
                height={"100%"}
                alt="outblock"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </Box>
          </Flex>
          {/* </Flex> */}

          {/* <Flex
        sx={{gap:"25%"}}
        > */}
          <Tiles
            columns={[2, 2, 3]}
            sx={{
              userSelect: "none",
              my: "20px",
              gap: "0px",
              // mx: "20px",
              flex: 3,
            }}
          >
            <Flex
              flexDirection="column"
              sx={{
                gap: "36px",
                minWidth: "200px",
              }}
            >
              <Text
                fontSize={["18px", "18px", "22px"]}
                sx={{
                  color: "#FFFFFF",
                  fontFamily: "Inter,sans-serif",
                  fontWeight: "bold",
                }}
              >
                Connection
              </Text>
              <Flex flexDirection="column" sx={{ gap: "10px" }}>
                {connection(
                  faDiscord,
                  "Discord",
                  "#FFFFFF",
                  "https://outblock.notion.site/Lilico-Documentation-Index-b97f6c9203384a80994161e8d00ce1b5"
                )}
                {connection(
                  faTwitter,
                  "Twitter",
                  "#FFFFFF",
                  "https://twitter.com/lilico_app"
                )}
                {connection(
                  faInstagram,
                  "Instagram",
                  "#FFFFFF",
                  "https://www.instagram.com/lilico_app"
                )}
                {connection(
                  faBook,
                  "Documentation",
                  "#FFFFFF",
                  "https://outblock.notion.site/Lilico-Documentation-Index-b97f6c9203384a80994161e8d00ce1b5"
                )}
                {connection(faAt, "Email", "#FFFFFF", "mailto:hi@lilico.app")}
                <a download href="/files/lilico-media-kit.zip">
                  {connection(faFileArchive, "Media Kit", "#FFFFFF", null)}
                </a>
              </Flex>
            </Flex>
            <Flex
              flexDirection="column"
              sx={{ gap: "36px", minWidth: "200px" }}
            >
              <Text
                fontSize={["18px", "18px", "22px"]}
                sx={{
                  color: "#FFFFFF",
                  fontFamily: "Inter,sans-serif",
                  fontWeight: "bold",
                }}
              >
                Support
              </Text>
              <Flex flexDirection="column" sx={{ gap: "20px" }}>
                <Link
                  fontSize={["14px", "14px", "18px"]}
                  sx={{ color: "#FFFFFF" }}
                  href="/about/terms"
                >
                  Terms of Use
                </Link>
                <Link
                  fontSize={["14px", "14px", "18px"]}
                  sx={{ color: "#FFFFFF" }}
                  href="/about/terms"
                >
                  Conditions
                </Link>
                <Link
                  fontSize={["14px", "14px", "18px"]}
                  sx={{ color: "#FFFFFF" }}
                  href="/about/privacy-policy"
                >
                  Privacy Policy
                </Link>
              </Flex>
            </Flex>

            <Flex
              flexDirection="column"
              sx={{
                gap: "36px",
                alignItems: "flex-start",
                minWidth: "250px",
                [theme.breakpoints.down("md")]: {
                  padding: "40px 0",
                },
              }}
            >
              <Text
                fontSize={["18px", "18px", "22px"]}
                sx={{
                  color: "#FFFFFF",
                  fontFamily: "Inter,sans-serif",
                  fontWeight: "bold",
                }}
              >
                Team and Company
              </Text>
              <Link
                fontSize={["14px", "14px", "18px"]}
                sx={{ color: "#FFFFFF", fontWeight: "normal" }}
                href="https://outblock.io"
              >
                About Outblock
              </Link>
            </Flex>

          </Tiles>
        </Tiles>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Footer2;
